var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30827 3.44827L4.83765 1.69189",
    stroke: "#141E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0076 4.74894L2.25122 4.27832",
    stroke: "#141E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.051 9.19043L12.8074 9.66105",
    stroke: "#141E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75024 10.4912L10.2209 12.2476",
    stroke: "#141E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52821 6.42862C9.82204 6.48484 10.1252 6.46824 10.4111 6.38027C10.697 6.2923 10.9571 6.13564 11.1685 5.92397L12.9595 4.1329C13.1298 3.96262 13.2649 3.76047 13.3571 3.53798C13.4492 3.3155 13.4966 3.07704 13.4966 2.83622C13.4966 2.59541 13.4492 2.35695 13.3571 2.13447C13.2649 1.91198 13.1298 1.70983 12.9595 1.53955C12.7893 1.36926 12.5871 1.23419 12.3646 1.14203C12.1421 1.04987 11.9037 1.00244 11.6629 1.00244C11.422 1.00244 11.1836 1.04987 10.9611 1.14203C10.7386 1.23419 10.5365 1.36926 10.3662 1.53955L8.57514 3.3306C8.36347 3.54201 8.2068 3.80205 8.11883 4.08799C8.03086 4.37392 8.01426 4.67705 8.07048 4.97089",
    stroke: "#141E2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47064 7.57122C5.17681 7.51499 4.87368 7.53159 4.58774 7.61956C4.30181 7.70753 4.04177 7.8642 3.83036 8.07587L2.0393 9.86692C1.86902 10.0372 1.73394 10.2394 1.64179 10.4618C1.54963 10.6843 1.5022 10.9228 1.5022 11.1636C1.5022 11.4044 1.54963 11.6429 1.64179 11.8654C1.73394 12.0878 1.86902 12.29 2.0393 12.4603C2.20958 12.6306 2.41174 12.7656 2.63422 12.8578C2.85671 12.95 3.09516 12.9974 3.33598 12.9974C3.5768 12.9974 3.81525 12.95 4.03774 12.8578C4.26022 12.7656 4.46238 12.6306 4.63266 12.4603L6.42371 10.6692C6.63538 10.4578 6.79205 10.1978 6.88002 9.91184C6.968 9.6259 6.9846 9.32277 6.92837 9.02894",
    stroke: "#141E2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnbound);
export default __webpack_public_path__ + "static/media/ic_unbound.54747021e9d190f7f82044199717941e.svg";
export { ForwardRef as ReactComponent };